import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ZintModalConfig, ZintModalContent } from '../../../classes/types';
declare var $: any;

@Component({
  selector: 'zint-modal',
  templateUrl: './zint-modal.component.html',
  styleUrl: './zint-modal.component.css',
  standalone: false,
})
export class ZintModalComponent {
  @Input() modalConfig: ZintModalConfig = {
    size: 'md',
    showHeaderRow: true,
    vCentered: false,
    showConfirmBtn: false,
    name: '',
  };
  @Input() modalContent: ZintModalContent;

  @Output() onConfirm = new EventEmitter<boolean>();
  @Output() onDismiss = new EventEmitter();

  ngAfterViewInit(): void {
    const modalId = '#zintModal-' + this.modalConfig.name;
    $(modalId).on('hide.bs.modal', () => {
      this.onDismiss.emit();
    });
  }

  getModalSizeAndCenterClasses(): string {
    const { size, vCentered } = this.modalConfig;
    let classList = '';
    if (size) {
      classList += `modal-${size}`;
    }

    if (vCentered) {
      classList += ' modal-dialog-centered'; //keep the leading space!
    }

    return classList;
  }

  onConfirmClick(): void {
    // emit confirm action as true
    this.onConfirm.emit(true);
  }
}
